import React from 'react';
import { string, bool, object, func } from 'prop-types';
import { InlineTextButton } from '../../../components';
import classNames from 'classnames';

import css from './AlphabetFilter.module.css';

const AlphabetButton = props => {
  const { letter, isSelected, onClick } = props;

  return (
    <InlineTextButton
      type="button"
      className={classNames(css.letterButton, {
        [css.letterButtonSelected]: isSelected,
      })}
      onClick={() => onClick(letter)}
    >
      {letter.toUpperCase()}
    </InlineTextButton>
  );
};

AlphabetButton.propTypes = {
  letter: string.isRequired,
  isSelected: bool.isRequired,
  onClick: func.isRequired,
};

const AlphabetFilter = props => {
  const { rootClassName, className, urlQueryParams, getHandleChangedValueFn } = props;
  const classes = classNames(rootClassName || css.root, className);

  // Generate an array of letters from 'a' to 'z'
  const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(97 + i));

  // Handle letter click
  const handleLetterClick = letter => {
    const updatedQueryParams = { ...urlQueryParams, pub_alphabet: letter };
    const useHistoryPush = true;
    getHandleChangedValueFn(useHistoryPush)(updatedQueryParams);
  };

  return (
    <div className={classes}>
      {alphabet.map(letter => (
        <AlphabetButton
          key={letter}
          letter={letter}
          isSelected={urlQueryParams.pub_alphabet === letter}
          onClick={handleLetterClick}
        />
      ))}
      <AlphabetButton
        key="0-9"
        letter="0-9"
        isSelected={urlQueryParams.pub_alphabet === '0-9'}
        onClick={handleLetterClick}
      />
    </div>
  );
};

AlphabetFilter.defaultProps = {
  rootClassName: null,
  className: null,
};

AlphabetFilter.propTypes = {
  rootClassName: string,
  className: string,
  urlQueryParams: object.isRequired,
  getHandleChangedValueFn: func.isRequired,
};

export default AlphabetFilter;
